export default __webpack_public_path__ + "static/media/blob5.a77e4e48.svg";